/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddressBookItem } from '../../models/address-book-item';
import { BaseResponse } from '../../models/base-response';

export interface OfficeControllerFindOneAddressBook$Params {
  id: number;
}

export function officeControllerFindOneAddressBook(http: HttpClient, rootUrl: string, params: OfficeControllerFindOneAddressBook$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AddressBookItem;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerFindOneAddressBook.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AddressBookItem;
      }>;
    })
  );
}

officeControllerFindOneAddressBook.PATH = '/company/office/addressbook/{id}';
